const elementExists = document.querySelectorAll('.select-css-sortable');

Array.from(elementExists).forEach((selectWrap) => {
  if (typeof selectWrap !== 'undefined' && elementExists !== null) {
    const select = selectWrap.querySelector('select');
    if (select.value !== '') {
      selectWrap.classList.add('clear');
    }
    select.onchange = () => {
      if (select.value !== '') {
        selectWrap.classList.add('clear');
        select.form.submit();
      } else {
        selectWrap.classList.remove('clear');
        select.form.submit();
      }
    };
  }
});
